import axios from 'axios';
import config from 'config';

export default (/* store */) => async ({ apiPath = '', ...rest }) => {
  const options = {
    url: config.apiURL + apiPath,
    ...rest
  };

  try {
    const { data } = await axios(options);
    if (data.error) {
      throw new Error(data.error);
    }
    return data;
  } catch (error) {
    if (error.response && error.response.data && error.response.data.error) {
      throw new Error(error.response.data.error.message);
    }
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/utils/api.js